export enum AggregatorOutputModeEnum {
  Text = 0,
  Popon = 1,
  Rollup = 2,
}

export type AggregatorOutputMode =
  | AggregatorOutputModeEnum.Text
  | AggregatorOutputModeEnum.Popon
  | AggregatorOutputModeEnum.Rollup;
